module.exports = __webpack_public_path__ + "static/media/template1.b7d901b3.jpg";